// 全站共用的少量常量。目前只有管理员账号 ID——多个组件（App.jsx 的数据看板
// 入口、EarlyBirdTab.jsx 的联系方式解锁额度）都需要判断"当前登录的是不是管理员"，
// 抽出来避免同一个 UID 字面量在多个文件里各写一份、容易漂移。
export const ADMIN_UID = '8f258507-e2ac-488d-9302-9e668a102208';
